<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import DButton from '#layers/ui/components/Button.vue';

defineOptions({
	name: 'ButtonRetry',
});

withDefaults(defineProps<ButtonProps>(), {
	color: 'neutral',
	variant: 'outline',
	size: 'sm',
	// Otherwise both are set to `false` and NuxtLink will detect a conflict
	prefetch: undefined,
	noPrefetch: undefined,
});
</script>

<template>
	<!-- Undeclared attributes reach `DButton` on their own, so only props are forwarded here.
		`label` goes last so it wins over the `undefined` the spread carries. -->
	<DButton
		v-bind="$props"
		:label="label ?? $t('common.retry')"
	>
		<slot />
	</DButton>
</template>
